module.exports = __webpack_public_path__ + "static/media/PL.43bf4228.png";